import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import swal from "sweetalert";
import axios from "axios";
import ImageModal from "./Image";

const Category = () => {
  const [show, setShow] = useState(false);
  const [allcategory, updateCategory] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // Number of items per page


  const [title, pickTitle] = useState(""); // Define the 'title' variable
  const [image, pickImg] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const baseurl = "https://apimlm.bloomitsolutions.in";

  const getCategory = async () => {
    try {
      const response = await fetch(
        "https://apimlm.bloomitsolutions.in/ecomroutes/getCategories"
      );
      if (response.ok) {
        const data = await response.json();
        updateCategory(data.reverse());
        console.log("errrrrrrrrrrr", data);
      } else {
        throw new Error("Failed to fetch data");
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  const deleteCategory = (categoryId, categoryName) => {
    axios
      .delete(`https://apimlm.bloomitsolutions.in/ecomroutes/deleteCategory?id=${categoryId}`)
      .then((response) => {
        if (response.data.success) {
          // Filter out the deleted category from the list
          const updatedCategories = allcategory.filter(category => category.id !== categoryId);
          updateCategory(updatedCategories);
          
          // swal("Success", `Category ${categoryName} deleted successfully`, "success");
        } else {
          console.error("Server response:", response);
          // swal("Error", `Failed to delete category: ${response.data.message}`, "error");
        }
      })
      .catch((error) => {
        console.error("Request error:", error);
        // swal("Error", `Failed to delete category: ${error.message}`, "error");
      });
  };



  useEffect(() => {
    getCategory();
  }, []);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = allcategory.slice(indexOfFirstItem, indexOfLastItem);

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(allcategory.length / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  const save = () => {
    let formData = new FormData();
    formData.append("cetogery_name", title);
    formData.append("image", image);

    fetch("https://apimlm.bloomitsolutions.in/ecomroutes/createCategory", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((serverRes) => {
        swal(title, "Save Successfully", "success");
        getCategory();
        handleClose();
      })
      .catch((error) => {
        console.error("Error:", error);
        swal("Error", "Failed to save data: " + error.message, "error");
      });
  };

  const [showImageModal, setShowImageModal] = useState(false);
  const [enlargedImageUrl, setEnlargedImageUrl] = useState("");


  const openImageModal = (imageUrl) => {
    setEnlargedImageUrl(imageUrl);
    setShowImageModal(true);
  };

  const closeImageModal = () => {
    setEnlargedImageUrl("");
    setShowImageModal(false);
  };

  return (
    <section>
      <div className="container-fluid mt-4">
        <div className="row">
          <div className="col-lg-1 text-end">
            <Link to="/">
              <h6>
                <i className="fa fa-home" aria-hidden="true"></i>Home
              </h6>
            </Link>
          </div>
          /
          <div className="col-lg-5">
            <h6>Category </h6>
          </div>
          <div className="col-lg-10 mt-3 mb-3">
            <div className="card border-0 shadow ">
              <div className="card-header bg bg-info border-0">
                <h4>List Of Category </h4>
              </div>
              <div className="card-body">
                <div className="col-lg-12 ">
                  <div className="row text-end">
                    <div className="col-lg-6"></div>
                    <div className="col-lg-3"></div>
                    <div className="col-lg-3">
                      <button
                        className="btn btn-success"
                        variant="primary"
                        onClick={handleShow}
                      >
                        Create New Category
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 mt-3">
                  <div className="table-responsive">
                    <table className="table table-bordered  mb-0 text-nowrap">
                      <thead>
                        <tr>
                          <th>Sl No</th>
                          <th>Name</th>
                          <th style={{ width: "50%" }}>Image</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.map((category, index) => {
                          const slNo = index + 1 + (currentPage - 1) * itemsPerPage;
                          return (
                            <tr key={index}>
                              <td>{slNo}</td>
                              <td>{category.cetogery_name}</td>
                              <td>
                                <img
                                  src={`${baseurl}/${category.cetogery_image}`}
                                  className="img-fluid"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    maxWidth: "100px",
                                    maxHeight: "100px",
                                  }}
                                  onClick={() => openImageModal(`${baseurl}/${category.cetogery_image}`)}
                                />
                              </td>
                              <td>
                                <button
                                  className="btn btn-danger"
                                  onClick={() => deleteCategory(category.id, category.cetogery_name)}
                                >
                                  Delete
                                </button>

                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Pagination controls here */}
      <ul className="pagination">
        {pageNumbers.map((number) => (
          <li
            key={number}
            className={`page-item ${currentPage === number ? 'active' : ''}`}
          >
            <button
              onClick={() => setCurrentPage(number)}
              className="page-link"
            >
              {number}
            </button>
          </li>
        ))}
        <div className="col-lg-3">
          {currentPage > 1 && (
            <button
              className="btn btn-primary"
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              Previous
            </button>
          )}
        </div>
        <div className="col-lg-3">
          {currentPage < pageNumbers.length && (
            <button
              className="btn btn-primary"
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              Next
            </button>
          )}
        </div>
      </ul>
      <div
        className="modal show"
        style={{ display: "block", position: "initial" }}
      >
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Additional Category</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Image</Form.Label>
              <Form.Control

                type="file"
                className="custom-file-input"
                accept="image/*"
                onChange={(e) => pickImg(e.target.files[0])}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Name"
                onChange={(obj) => pickTitle(obj.target.value)}
                value={title}
              />
            </Form.Group>




          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button
              variant="primary"
              onClick={save}
            >
              save
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      {showImageModal && (
        <ImageModal
          isOpen={showImageModal}
          onRequestClose={closeImageModal}
          imageUrl={enlargedImageUrl}
        />
      )}
    </section>
  );
};

export default Category;
